import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import { useCreateOrderingPlatform } from "./useCreateOrderingPlatform";
import Form, { OrderingPlatformFormProps } from "./Form";

const FORM_ID = "create-ordering-platform-form";

type Props = Pick<ModalProps, "isOpen" | "onClose"> &
  Pick<OrderingPlatformFormProps, "defaultValues"> & {
    isAdmin?: boolean;
    onCompleted: (id: UUID) => void;
  };

export default function CreateOrderingPlatformModal({
  defaultValues,
  isAdmin,
  isOpen,
  onClose,
  onCompleted,
}: Props) {
  const { handleValidSubmit, isSaving } = useCreateOrderingPlatform(isAdmin);

  return (
    <Modal {...{ isOpen, onClose }} size="md" blockScrollOnMount={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add New Customer</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Form
            defaultValues={defaultValues}
            formId={FORM_ID}
            isAdmin={isAdmin}
            onSubmit={(evt) => {
              evt.stopPropagation();
            }}
            onValidSubmit={(formData, context) =>
              handleValidSubmit(formData, context).then((result) => {
                const newId =
                  result?.data?.createOrderingPlatform?.orderingPlatform?.id;
                if (newId) onCompleted(newId);
              })
            }
          />
        </ModalBody>
        <ModalFooter justifyContent="center">
          <Button
            type="submit"
            size="sm"
            colorScheme="pinkButton"
            leftIcon={<AddIcon />}
            isLoading={isSaving}
            form={FORM_ID}
          >
            Add New Customer
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
